/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import {themeToken} from "../../utils/cpds-utils";
import {checkValue} from "src/components/common/helper";
import {Typo} from "src/components/common/ui";

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} */




const CpdsCaptionsStyleTag = styled.ul`
  ${({ theme: { styles : {cpds} } }) => css`
    
    ${(props) => props?.styleOverrides}
  `}
`;


const CpdWrapperStyle = styled.div`
  ${({ theme: { styles : {cpds} },...props }) => {
        
      const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

      return  css`
        width:100%;
        display:flex;
        justify-content:start;
        max-width:140px;
        background-color: ${token?.caption_background_color || 'red'};


        ${(props) => props?.styleOverrides}
      `
    }
  }
`

const CpdsUlStyleTag = styled.ul`
  ${({ theme: { styles : {cpds} }, ...props

    }) => {
      
      const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
      return css`
        list-style-type: none;
        display: flex;
        flex-direction:${props => props?.changeOrder? 'row-reverse' :'row'};
        /* flex-wrap: wrap;*/
        gap:${(props) => props?.gapBetween || '8px'};
      `
    }
  }
`;


const CpdsCaptionbSVG = styled.div`
    ${({ theme: { styles: { cpds } },
      ...props
    }) => {
        const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
        return css`
          margin-top:${props => props?.iconTopMargin || '4px'};
      `
      }
    }
`;

const CpdLiStyleTag = styled.li`
  ${({ theme: { styles : {cpds} },
    ...props

  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      display: ${props => props?.hoverEffect ?'none':'initial'};
      ${props => props?.hoverEffect ? `${CpdsUlStyleTag}: hover & { display: initial; } `: ''}
      `
    }
  }
`


//'#676A7D' themeMode(cpds)?.[bgTheme]?.color

const CpdPstyleTag = styled(Typo.HTMLText).attrs(()=>({
  tag:'p',
}))`
  ${({ theme: { styles : {cpds} },
    fontColor,
    fontSize,
    lineHeigh,
    fontWeight,
    ...props

  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
        color: ${fontColor || token.caption_font_color || 'red'} ;
        ${checkValue(fontSize)? `font-size: ${fontSize} !important;` : ''};
        ${checkValue(lineHeigh)? `line-height: ${lineHeigh} !important;` : ''};
        ${checkValue(fontWeight)? `font-weight: ${fontWeight} !important;` : ''};
      `
    }
  }
` 
export { CpdsCaptionsStyleTag,CpdWrapperStyle, CpdsUlStyleTag, CpdLiStyleTag,CpdsCaptionbSVG, CpdPstyleTag };
